/*
 * create by wq on 2019/01/30
 * */

//使用示例
/*
$.initGateway({
    currentAppid: 500, //当前系统的appId，必填
    headerSelector: '#pageHeader', //放置头部的选择器，非必填
    sysNavSelector: 'body', //放置系统导航栏的选择器，非必填
    blocks: [   //必填
        {
            "appId": 0,
            "appName": "门户首页",
            "path": "/views/index.html"
        }, {
            "appId": 300,
            "appName": "热点发现",
            "path": "/hot/views/loading/loading-gateway.html"
        }, {
            "appId": 400,
            "appName": "线索汇聚",
            "path": "/clue/views/loading/loading-gateway.html"
        }, {
            "appId": 500,
            "appName": "传播分析",
            "path": "/analysis/views/loading/loading-gateway.html"
        }
    ]
})*/

// 引入样式文件
import "../css/gateway.less";
import { sysTheme, partPath } from '../../../scripts/common/variables.js';

//从缓存中获取用户信息
var userInfo = JSON.parse(window.localStorage.getItem("ccTenantUserInfo"));
var tenantId = userInfo.tenantId;
//用户名
var userName = userInfo ? userInfo.userName : "无登陆模式";
//从缓存中获取地址信息
var configs = JSON.parse(window.localStorage.getItem("configs"));
// 获取登陆过期时间戳
var timestamp = new Date().getTime()

//创建构造函数Gateway
var Gateway = function (options) {
  this.options = options;
  this.$headerElement = $(this.options.headerSelector);
  this.$sysNavElement = $(this.options.sysNavSelector);
  this.methods = {
    appendHtml: function ($element, html) {
      $element.append(html);
    },
    setUserName: function (userName) {
      $("#gatewayUserName").text(userName);
    },
  };
  if (options.currentAppid === undefined || options.currentAppid == null) {
    console.error("必填参数currentAppid缺失，导致gateway插件无法正常运行!");
    return false;
  }
  if (
    options.headerSelector === "" ||
    options.headerSelector === undefined ||
    options.headerSelector == null
  ) {
    console.warn("参数headerSelector是必要参数，不填可能会导致头部样式异常！");
    options.headerSelector = "body";
  }
  if (
    options.sysNavSelector === "" ||
    options.sysNavSelector === undefined ||
    options.sysNavSelector == null
  ) {
    options.sysNavSelector = "body";
  }
  if (options.blocks === undefined || options.blocks == null) {
    console.error("必填参数blocks缺失，导致gateway插件无法正常运行!");
    return false;
  }
  if (options.blocks.length === 0) {
    console.error("blocks为空数组，导致gateway插件无法正常运行!");
    return false;
  }
};

Gateway.prototype = {
  loadCss: function (url) {
    var link = document.createElement("link");
    link.type = "text/css";
    link.rel = "stylesheet";
    link.href = url;
    document.getElementsByTagName("head")[0].appendChild(link);
  },
  initHeader: function () {
    var headerHtml =
      "\n" +
      '<div id="gatewayPageHeader">\n' +
      ' <div class="gateway-logo">\n' +
      '   <a href="javascript:;"></a>\n' +
      " </div>\n" +
      ' <div class="gateway-login-box">\n' +
      '   <div class="gateway-msg">\n' +
      '    <div class="bell-box"><svg class="icon" aria-hidden="true"><use xlink:href="#icon-msg"></use></svg></div>\n' +
      '    <div class="gateway-msg-box">\n' +
      '     <div class="mask"></div>\n' +
      '     <div class="gateway-msg-header"><span>订阅消息</span><svg class="icon" aria-hidden="true"><use xlink:href="#icon-common-delete"></use></svg></div>\n' +
      '     <ul class="gateway-msg-list"><li class="gateway-no-msg">暂无消息</li></ul>\n' +
      '    </div>\n' +
      '   </div>\n' +
      '   <div class="gateway-login-userInfo">\n' +
      '     <img src="//cdn.bigdata.cloud.dayang.com.cn/common/userAvatar2.png" alt="无法加载">\n' +
      '     <span id="gatewayUserName"></span>\n' +
      "   </div>\n" +
      '   <a href="'+ partPath +'/common/logout" id="gatewayLogout">退出</a>\n' +
      " </div>\n" +
      "</div>";
    this.methods.appendHtml(this.$headerElement, headerHtml);
    this.methods.setUserName(userName);
    //设置logo图片
    var defaultLogoImgUrl =
      "//cdn.bigdata.cloud.dayang.com.cn/common/bigdata_logo.png";
    var logoImgUrl = (configs && configs.logoImgUrl) || defaultLogoImgUrl;
    $(".gateway-logo >a").css({
      background: "url('" + logoImgUrl + "') center center no-repeat",
      "-webkit-background-size": "contain",
      "background-size": "contain",
    });
  },
  initSysNav: function () {
   $('#pageSidebarMenu').show();
    var sysNavHtml =
      "\n" + '<div id="gatewaySysNav">\n' + "  <ul>\n" + "  </ul>\n" + "</div>";
    this.methods.appendHtml(this.$sysNavElement, sysNavHtml);
    var currentAppid = this.options.currentAppid;
    $(this.options.blocks).each(function (i, v) {
      if (v.appId !== currentAppid) {
        $("#gatewaySysNav ul").append(
          '<li class="gateway-sys-nav-item" id="gatewaySysNavItem' +
            v.appId +
            '" title="' +
            v.appName +
            '"><a href="' +
            v.path +
            "?timestamp=" +
            timestamp +
            '">' +
            '<img src="' +
            v.icon +
            '" alt="无法加载">' +
            v.appName +
            "</a></li>"
        );
      } else {
        $("#gatewaySysNav ul").append(
          '<li class="gateway-sys-nav-item active" id="gatewaySysNavItem' +
            v.appId +
            '" title="' +
            v.appName +
            '"><a href="' +
            v.path +
            "?timestamp=" +
            timestamp +
            '">' +
            '<img src="' +
            (sysTheme !== 'cnooc' ? v.activeIcon : v.icon) +
            '" alt="无法加载">' +
            v.appName +
            "</a></li>"
        );
        $("#pageSidebarMenu").prepend(
          '<li style="height: 60px; line-height: 60px;padding-left: 70px;color: #454e66;font-size:16px; " id="firstPageSidebar">' +
            v.appName +
            "</li>"
        );
      }
    });
    var isFold = true;
    $("#gatewaySysNav")
      .on("mouseenter", function () {
        isFold = false;
        setTimeout(function () {
          if (!isFold) $("#gatewaySysNav").css("width", "200px");
        }, 500);
      })
      .on("mouseleave", function () {
        isFold = true;
        $("#gatewaySysNav").css("width", "50px");
      });
  },
  initFastSysNav: function () {
   $('#pageSidebarMenu').hide();
    var sysNavHtml = '<ul class="fast-sys-navs" id="fastSysNavs"></ul>';
    this.methods.appendHtml(this.$sysNavElement, sysNavHtml);
    $(this.options.blocks).each(function (i, v) {
     $("#fastSysNavs").append(
      `<li class="sys-nav-item" id="sysNav${v.appId}">
       <div class="sys-nav-header" data-path="${v.path}">
        <div class="sys-nav-icon"></div>
        <span class="sys-nav-title">${v.appName}</span>
        <em class="sys-nav-arrow"></em>
       </div>
      </li>`
     );
    });
    $(`#sysNav${this.options.currentAppid}`).addClass('active');
    $("#fastSysNavs").on('click', '.sys-nav-header', function(){
     let path = $(this).data('path') + `?timestamp=${timestamp}`;
     window.location.href = path;
    });
  },
  init: function () {
    //初始化插件
    if (this.options.initHeader) {
      // 是否初始化默认头部
      this.initHeader();
    }
    if(this.options.headerClassify === 'gateway' || tenantId === '3705'){
     this.initSysNav();
    }else{
     this.initFastSysNav();
    }
    
  },
};

export default Gateway;
